<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">二级代理商管理</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" label-width="160px" class="user-search">
            <el-form-item label="二级代理商名称">
                <el-input size="small" v-model="formInline.name" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="二级代理商注册手机号">
                <el-input size="small" v-model="formInline.phone" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
                <!-- <el-button size="small" type="primary" @click="addClick">创建总代理商</el-button> -->
            </el-form-item>
        </el-form>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column prop="nickname" label="二级代理商名称" ></el-table-column>
            <!-- <el-table-column prop="corporateName" label="法人名称" ></el-table-column> -->
            <!-- <el-table-column  prop="nickname" label="是否认证" ></el-table-column> -->
            <el-table-column show-overflow-tooltip prop="phone" label="二级代理商注册手机号" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="bindMachineNum" label="绑定机器" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="bindStoreNum" label="绑定商家" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="createName" label="创建人" ></el-table-column>
            <el-table-column prop="createdAt" label="注册时间">
                <template slot-scope="scope">
                    <div>{{scope.row.createdAt|timestampToTime}}</div>
                </template>
            </el-table-column>

            <el-table-column prop="createdAt" label="门店开关">
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.yflag"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        @change="yflagchange(scope.row)"
                        inactive-color="#409EFF">
                    </el-switch>
                </template>
            </el-table-column>
            <el-table-column prop="createdAt" label="有麻gamebar开关">
                <template slot-scope="scope">
                    <el-switch
                        v-model="scope.row.barflag"
                        :active-value="1"
                        :inactive-value="0"
                        active-color="#13ce66"
                        @change="barflagChagne(scope.row)"
                        inactive-color="#409EFF">
                    </el-switch>
                </template>
            </el-table-column>
            <!-- <el-table-column  prop="status" label="所属上级" ></el-table-column> -->
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                <el-button size="mini" type="text" @click="customerService(scope.row)">上传客服信息</el-button>
                <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">查看详情</el-button>
                <el-button size="mini" type="text" v-preventReClick @click="editMchid(scope.row)">修改商户号</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editFormRef">
                <el-form-item label="代理商名称：" prop="nickname">
                <el-input size="small" v-model="editForm.nickname" style="width:230px" auto-complete="off" placeholder="请输入代理商名称"></el-input>
                </el-form-item>
                <el-form-item label="公司法人：" prop="corporateName">
                <el-input size="small" v-model="editForm.corporateName" style="width:230px" placeholder="请输入公司法人名称"></el-input>
                </el-form-item>
                <el-form-item label="注册手机号码：" prop="phone">
                <el-input size="small" v-model="editForm.phone" style="width:230px" auto-complete="off" placeholder="请输入手机号"></el-input>
                </el-form-item>
                <el-form-item label="银联商户号" >
                <el-input size="small" v-model="editForm.mchid" style="width:230px" auto-complete="off" placeholder="请输入商户号"></el-input>
                </el-form-item>
                <el-form-item label="所在地：" prop="area">
                    <el-cascader
                        v-model="editForm.area"
                        :options="proData"
                        :props="{
                            value:'label'
                        }"
                        ></el-cascader>
                </el-form-item>
                
                <el-form-item label="共享桌费分润比例：" prop="division">
                     <el-input-number :disabled="editFlag" size="mini" :precision="2"  min="0" max="100" v-model="editForm.division"></el-input-number> %
                </el-form-item>
                <el-form-item label="权限设置">
                    默认拥有全部销售端权限
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="submitForm('editFormRef')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="二级代理商详情" :visible.sync="detailsFlag" width="50%" @click="closeDialog">
            <el-tabs type="border-card" v-model="activeName" @tab-click="tabClick">
                <el-tab-pane label="基本信息" name="information">
                    <el-descriptions column="1">
                        <template slot="extra">
                            <el-button type="primary" size="small" @click="editClick">编辑</el-button>
                        </template>
                        <el-descriptions-item label="二级代理商名称">{{ seeForm.nickname }}</el-descriptions-item>
                        <el-descriptions-item label="法人名称">{{ seeForm.corporateName }}</el-descriptions-item>
                        <el-descriptions-item label="注册手机号">{{seeForm.phone}}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ seeForm.createdAt|timestampToTime }}</el-descriptions-item>
                        <el-descriptions-item label="银联商户号">{{ seeForm.mchid }}</el-descriptions-item>
                        <el-descriptions-item label="共享桌费分润比例">{{ seeForm.division }}%</el-descriptions-item>
                        <el-descriptions-item label="绑定设备">{{ seeForm.bindMachineNum }}</el-descriptions-item>
                        <el-descriptions-item label="绑定商家">{{ seeForm.bindStoreNum }}</el-descriptions-item>
                        <el-descriptions-item label="所属一级代理商">{{ seeForm.distributorName }}</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane>
                <!-- <el-tab-pane label="认证信息" name="attestation">
                    <el-descriptions column="1">
                        <template slot="extra">
                            <el-button type="primary" size="small" @click="editClick">编辑</el-button>
                        </template>
                        <el-descriptions-item label="代理商名称">{{ seeForm.nickname }}</el-descriptions-item>
                        <el-descriptions-item label="注册手机号">{{seeForm.phone}}</el-descriptions-item>
                        <el-descriptions-item label="注册时间">{{ seeForm.createdAt|timestampToTime }}</el-descriptions-item>
                        <el-descriptions-item label="分成比例">{{ seeForm.createdAt|timestampToTime }}</el-descriptions-item>
                    </el-descriptions>
                </el-tab-pane> -->
                <el-tab-pane label="绑定的机器" name="machine">
                    <div style="margin-bottom:20px">
                        已绑定设备：{{currentTotal}}台 &nbsp;&nbsp; 
                        <!-- <el-button type="primary" @click="bindingClick" size="small">新增绑定</el-button> -->
                    </div>
                    <el-table size="small" :data="MachineList" max-height="400" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                        <el-table-column  prop="machineId" label="主屏id" ></el-table-column>
                        <el-table-column  prop="status" label="机器状态" >
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == 0">离线</span>
                                <span v-if="scope.row.status == 1">在线</span>
                            </template>
                        </el-table-column>
                        <el-table-column  prop="bindDistributorTime" label="绑定时间" >
                            <template slot-scope="scope">
                                <div>{{scope.row.bindDistributorTime|timestampToTime}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                            <el-button size="mini" type="text" v-preventReClick @click="Unbinding(scope.$index, scope.row)">解绑</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <el-pagination
                    background
                    @current-change="currentChange"
                    style="margin-top:20px"
                    layout="total ,prev, pager, next"
                    :total="currentTotal">
                </el-pagination>
                </el-tab-pane>
            </el-tabs>
        </el-dialog>
        <!-- 绑定机器 -->
        <el-dialog title="绑定机器" :visible.sync="bindingFlag" width="40%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" label-width="120px" class="user-search">
                    <!-- <el-form-item label="主屏id">
                        <el-input size="small" v-model="formInline.name" placeholder="昵称"></el-input>
                    </el-form-item> -->
                    <el-form-item label="">
                        <!-- <el-button size="small" type="primary" @click="search">搜索</el-button>
                        <el-button size="small" @click="empty">重置</el-button> -->
                        <el-button size="small" type="primary" v-preventReClick @click="batchClick">批量绑定</el-button>
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="machinesList" @selection-change="handleSelectionChange" max-height="400" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column  type="selection" width="55"></el-table-column>
                    <el-table-column  prop="machineId" label="主屏id" ></el-table-column>
                        <el-table-column  prop="status" label="机器状态" >
                            <template slot-scope="scope">
                                <span v-if="scope.row.status == 0">离线</span>
                                <span v-if="scope.row.status == 1">在线</span>
                            </template>
                        </el-table-column>
                    <!-- <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">添加</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>
        </el-dialog>

        <!-- 编辑分成比例 -->
        <el-dialog title="编辑分成比例" :visible.sync="editScaleFlag" width="50%" @click="closeDialog">
            <div class="editScale">
                    <div class="editScale_title">
                        批量修改平台比例
                    </div>
                    <el-input placeholder="比例" style="width:230px" @focus="terraceScalefocus" @blur="terraceScaleBlur" @change="terraceScaleChange" v-model="terraceScale">
                        <template slot="append">%</template>
                    </el-input>
                    <div class="editScale_title" style="width:300px">
                        代理商
                    </div>
                    <div class="editScale_title">
                        批量修改商家比例
                    </div>
                    <el-input placeholder="比例" style="width:230px" @focus="terraceScalefocus" @blur="terraceScaleBlur" @change="businessScaleChange" v-model="businessScale">
                        <template slot="append">%</template>
                    </el-input>
            </div>
            <div v-for="item in editScaleList" :key="item.id">
                <div class="editScale" >
                    <div class="editScale_title">
                        平台
                    </div>
                    <el-input placeholder="比例" style="width:230px" disabled="" v-model="item.divisionSystem">
                        <template slot="append">%</template>
                    </el-input>
                    <div style="display:flex;width:300px;justify-content: center;">
                        <div class="editScale_title">
                            代理商：{{editScaleForm.nickname}}
                        </div>
                        <div>
                            比例：{{100 - item.divisionStore - item.divisionSystem}}
                        </div>
                    </div>
                    <div class="editScale_title">
                        商家:{{ item.storeName }}
                    </div>
                    <el-input placeholder="比例" style="width:230px" v-model="item.divisionStore">
                        <template slot="append">%</template>
                    </el-input>
                </div>
                <div class="editScale_msg" v-if="item.msg != ''">{{item.msg}}</div>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editScaleFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" :disabled="submitFlag" v-preventReClick class="title" @click="editScalesubmit()">保存</el-button>
            </div>
        </el-dialog>

        <!-- 新增 -->
        <el-dialog :visible.sync="editMchidFlag" width="30%" @click="editMchidFlag = false">
            <el-form label-width="120px" :model="editMchidForm" :rules="rules" ref="editForm">
                <el-form-item label="商户号">
                <el-input size="small" v-model="mchid" style="width:230px" auto-complete="off" placeholder="请输入商户号"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="editMchidFlag = false">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="editMchidSubmit()">保存</el-button>
            </div>
        </el-dialog>


        <el-dialog title="上传客服信息" :visible.sync="customerServiceFlag" width="40%" @close="kfCloseDialog">
            <el-form label-width="120px" :model="customerServiceForm" :rules="rules" ref="customerServiceRef">
                <el-form-item label="客服图片：" prop="qrCode">
                    <el-upload
                        class="upload-demo"
                        :http-request="HandleChange2"
                        :file-list="FileList"
                        :on-exceed="onExceed"
                        :on-remove="handleRemove"
                        :limit="1"
                        style="margin-top:15px"
                        accept=".jpg , .png ,"
                        list-type="picture">
                        <el-button size="small" type="primary">点击上传</el-button>
                        </el-upload>
                </el-form-item>
                <el-form-item label="客服电话：" prop="phone">
                <el-input size="small" v-model="customerServiceForm.phone" style="width:230px" placeholder="请输入"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="kfCloseDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" v-preventReClick class="title" @click="customerServiceSubmit('customerServiceRef')">保存</el-button>
            </div>
        </el-dialog>

</div>
</template>
<script>
import { regionData  } from 'element-china-area-data'
import Pagination from '../../../components/Pagination'
import { storeUpdateFf ,
    createStoreUser ,
    updateStoreUser , 
    loadMachineList ,
    getMachineListNoBind,
    bindMachine,
    unBindMachine,
    loadDivisionList,
    updateDivision , 
    storeSelect , 
    updateMchid ,
    storeBranch,
    storeBarbranch} from '../../../api/userMG'
export default {
    data(){
        return{
            mchid:'',
            editMchidFlag:false,
            FileList:[],
            customerServiceFlag:false,
            customerServiceForm:{
                qrCode:'',
                phone:'',
                id:''
            },
            props: { 
                // multiple: true,
                emitPath:true,
                label:'name',
                value:'name',
                children:'areachildren'
            },
            proData:regionData,
            submitFlag:false,
            terraceScale:'',
            businessScale:'',
            editScaleForm:{},
            editScaleList:[],
            editScaleFlag:false,
            loading:false,
            editFlag:false,
            seeForm:{
                corporateName:''
            },
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{
                nickname:'',
                phone:'',
                division:''
            },
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                phone: '',
                name: '',
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            rules: {
                nickname : [
                { required: true, message: '请输入代理商名称', trigger: 'blur' }
                ],
                qrCode: [
                { required: true, message: '请上传客服图片', trigger: 'blur' }
                ],
                phone: [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    // {
                    //     pattern: /^1(3\d|47|5((?!4)\d)|7(0|1|[6-8])|8\d)\d{8,8}$/,
                    //     required: true,
                    //     message: '请输入正确的手机号',
                    //     trigger: 'blur'
                    // }
                ],
                division:[
                    { required: true, message: '请输入分成比例', trigger: 'blur' }
                ],
                area:[
                    { required: true, message: '请选择所在地', trigger: 'blur' }
                ],
            },
            currentPage:1,
            currentTotal:0,
            MachineList:[],
            machinesList:[],
            SelectionList:[]
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
    },
    methods:{
        barflagChagne(e){
            storeBarbranch({
                storeId:e.id,
                barflag:e.barflag
            }).then(res=>{

            })
        },
        yflagchange(e){
            storeBranch({
                storeId:e.id,
                yflag:e.yflag
            }).then(res=>{

            })
        },
        editMchid(row){
            this.editMchidFlag = true
            this.mchid = row.mchid
            this.editMchidForm = row
        },
        editMchidSubmit(){
            updateMchid({
                id:this.editMchidForm.id,
                mchid:this.mchid
            }).then(res=>{
                if(!res.success){
                    this.$message.error(res.message)
                }else {
                    this.$message.success('操作成功')
                    this.mchid = ''
                    this.getdata()
                    this.editMchidFlag = false
                }
            })
        },
        customerServiceSubmit(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    storeUpdateFf(this.customerServiceForm).then(res=>{
                        if(!res.success){
                            this.$message.error(res.message)
                        }else {
                            this.$message.success('操作成功')
                            this.customerServiceFlag = false
                            this.FileList = []
                            this.getdata()
                        }
                    })
                } else {
                    return false
                }
            })
        },
        kfCloseDialog(){
            this.FileList = []
            this.customerServiceForm.qrCode = ''
            this.customerServiceFlag = false
        },
        // 上传帖子封面图
        HandleChange2(file){
            let formData = new FormData()
            formData.append('file' , file.file)
            this.$axios({
                method: "POST",
                url: "/yunyue-houtai/file/upload",
                headers: {
                    "Content-Type": "multipart/form-data",
                    token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
                },
                data: formData,
            }).then(res=>{
                this.customerServiceForm.qrCode = res.data.data
                this.FileList.push({
                    url:res.data.data
                })
            })
        },
        handleRemove(e){
            this.FileList = []
            this.customerServiceForm.qrCode = ''
        },
        customerService(item){
            let data = JSON.parse(JSON.stringify(item))
            this.customerServiceFlag = true
            this.customerServiceForm = {
                id:data.id,
                phone:data.csPhone,
                qrCode:data.qrCode
            }
            if(data.qrCode != null){
                this.FileList = [{url:`${data.qrCode}`}]
            }
        },
        terraceScalefocus(){
            this.submitFlag = true
        },
        terraceScaleBlur(){
            this.submitFlag = false
        },  
        editScalesubmit(){
            var regExp = new RegExp('^\\d{1,10}([.]\\d{1,2})?$');
            var reg = /^([1-9][0-9]*|0)(\.[0-9]*[1-9])?$/
            let data = JSON.parse(JSON.stringify(this.editScaleList))
            let dataFlag =  true
            for(let item of data){
                console.log(Number(item.divisionStore) + Number(item.divisionSystem))
                if(!reg.test(item.divisionStore)){
                    console.log("0001")
                    item.msg = '商家分成比例格式错误'
                    dataFlag = false
                }else if(reg.test(item.divisionStore) && !regExp.test(item.divisionStore)){
                    item.msg = '商家小数点保留两位'
                    console.log("0002")
                    dataFlag = false
                }else if (item.divisionStore > 100) {
                    console.log("0003")
                    item.msg = '商家分成比例不能大于100'
                    dataFlag = false
                }else if((Number(item.divisionStore) + Number(item.divisionSystem)) > 100){
                    console.log("0004")
                    item.msg = '平台分成比例与商家分成比例想加不能超过100'
                    dataFlag = false
                }else {
                    item.msg = ''
                    item.divisionStore = item.divisionStore.toString()
                    item.b = Math.round((100 - (Number(item.divisionStore) + Number(item.divisionSystem)))*100)/100
                }
            }
            if(dataFlag){
                console.log(data)
                this.editScaleList = data
                updateDivision({
                    distributorId:this.editScaleForm.id,
                    divisionDistributor:(100 - this.terraceScale).toString() ,
                    divisionSystem:this.terraceScale.toString(),
                    storeDetail:JSON.stringify(data),
                }).then(res=>{
                    console.log(res)
                    if(res.success){
                        this.$message.success('修改成功')
                        this.editScaleFlag = false
                        this.getdata()
                    }else {
                        this.$message.error(res.messages)
                    }
                    
                })
            }else {
                console.log(data)
                this.editScaleList = data
            }
        },
        businessScaleChange(e){
            this.submitFlag = false
            var regExp = new RegExp('^\\d{1,10}([.]\\d{1,2})?$');
            var reg = /^([1-9][0-9]*|0)(\.[0-9]*[1-9])?$/
            if(!reg.test(e)){
                this.$message.error('分成比例格式错误')
            }else if(reg.test(e) && !regExp.test(e)){
                this.$message.error('小数点保留两位')
            }else if(e > 100) {
                this.$message.error('分成比例不能大于100')
            }else {
                console.log(e)
                let data = this.editScaleList
                for(let item of data){
                    item.divisionStore = e
                }
                this.editScaleList = data
            }
        },
        terraceScaleChange(e){
            this.submitFlag = false
            var regExp = new RegExp('^\\d{1,10}([.]\\d{1,2})?$');
            var reg = /^([1-9][0-9]*|0)(\.[0-9]*[1-9])?$/
            if(!reg.test(e)){
                this.$message.error('分成比例格式错误')
            }else if(reg.test(e) && !regExp.test(e)){
                this.$message.error('小数点保留两位')
            }else if(e > 100) {
                this.$message.error('分成比例不能大于100')
            }else {
                console.log(e)
                let data = this.editScaleList
                for(let item of data){
                    item.divisionSystem = e
                }
                this.editScaleList = data
            }
        },
        editScale(row){ 
            console.log(row)
            this.editScaleForm = row
            loadDivisionList({
                page:1,
                pageSize:10000,
                type:1,
                id:row.id,
            }).then(res=>{
                if(res.pageInfo.list.length != 0){
                    this.terraceScale = res.pageInfo.list[0].divisionSystem
                    this.editScaleList = res.pageInfo.list
                    this.editScaleFlag = true
                }else{
                    this.terraceScale = 100 - row.division
                    this.editScaleList = []
                    this.editScaleFlag = true
                }
            })
        },
        batchClick(){
            console.log(this.SelectionList)
            console.log(this.seeForm.id)
            bindMachine({
                id:this.seeForm.id,
                machineIds:this.SelectionList
            }).then(res=>{
                if(res.success == true){
                    this.$message.success('绑定成功')
                    this.machinesList = []
                    this.tabClick()
                    this.bindingFlag = false
                }else {
                    this.$message.error(res.messages) 
                }
            })
        },
        handleSelectionChange(selection){
            this.SelectionList = []
            selection.forEach(item => {
                this.SelectionList.push(item.id);
            });
        },
        bindingClick(){
            this.bindingFlag = true
            getMachineListNoBind().then(res=>{
                this.machinesList = res.machines
            })
        },
        tabClick(){
            console.log(this.activeName)
            if(this.activeName == 'machine'){
                this.currentPage = 1
                this.loadMachineList()
            }
        },
        loadMachineList(){
            loadMachineList({
                page:this.currentPage,
                pageSize:'10',
                bindDistributorId:this.seeForm.id,
            }).then(res=>{
                this.MachineList = res.pageInfo.list
                this.currentTotal = res.pageInfo.total
            })
        },
        currentChange(e){
            this.currentPage = e
            this.loadMachineList()
        }, 
        submitForm(editData){
            this.$refs[editData].validate(valid => {
                if (valid) {
                    if(this.editFlag == true){
                        let data = this.editForm
                        data.province = this.editForm.area[0]
                        data.city = this.editForm.area[1]
                        data.district = this.editForm.area[2]
                        updateStoreUser(data).then(res=>{
                            if(res.success == false){
                                this.$message.success(res.messages)
                            }else {
                                this.$message.success('修改成功')
                                this.getdata()
                                this.seeForm.nickname = this.editForm.nickname
                                this.seeForm.phone = this.editForm.phone
                                this.seeForm.corporateName = this.editForm.corporateName
                                this.seeForm.province = this.editForm.area[0]
                                this.seeForm.city = this.editForm.area[1]
                                this.seeForm.district = this.editForm.area[2]
                                this.editFormVisible = false
                                this.editForm = {nickname:'' , phone:''}
                            }
                        })
                    }else {
                        let data = this.editForm
                        data.userType = 1
                        data.province = this.editForm.area[0]
                        data.city = this.editForm.area[1]
                        data.district = this.editForm.area[2]
                        createStoreUser(data).then(res=>{
                            if(res.success == false){
                                this.$message.success(res.messages)
                            }else {
                                this.$message.success('创建成功')
                                this.getdata()
                                this.editFormVisible = false
                                this.editForm = {nickname:'' , phone:''}
                            }
                            
                        })
                    }
                } else {
                    return false
                }
            })
        },
        editClick(){
            this.editFormVisible = true
            this.editFlag = true
            this.editForm = {
                nickname:this.seeForm.nickname,
                phone:this.seeForm.phone,
                division:this.seeForm.division,
                id:this.seeForm.id,
                userType:this.seeForm.userType,
                corporateName:this.seeForm.corporateName,
                area:[`${this.seeForm.province}`,`${this.seeForm.city}` ,`${this.seeForm.district}` ],
                mchid:this.seeForm.mchid
            }
            // this.editForm.nickname = this.seeForm.nickname
            // this.editForm.phone = this.seeForm.phone
            // this.editForm.division = this.seeForm.division
            // this.editForm.id = this.seeForm.id
            // this.editForm.userType = this.seeForm.userType
            
        },  
        handleEdit(index , row){
            this.detailsFlag = true
            this.activeName = 'information'
            this.seeForm = row
        },
        addClick(){
            this.editFormVisible = true
            this.editFlag = false
            this.editForm = {
                nickname:'',
                phone:'',
                division:''
            }
            this.$refs.editFormRef.clearValidate()
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.name = '' 
            this.formInline.phone = ''
            this.getdata()
        },
        search(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        getdata(){
            storeSelect({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                name:this.formInline.name,
                phone:this.formInline.phone,
                userType:2,
                otherdata:1
            }).then(res=>{
                this.listData = res.data.dataList
                this.pageparm.total = res.data.total
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
        Unbinding(index , row){
            this.$confirm('是否确认解绑?', '机器', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
            // 删除
            unBindMachine({machineId :row.id})
                    .then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '解绑成功!'
                            })
                            this.tabClick()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.messages
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('解绑失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消解绑！'
                })
            })
        },  
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .editScale{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-content: center;
    line-height: 40px;
    margin-bottom: 20px;
  }
  .editScale_title{
    width: 130px;
    text-align: center;
  }
  .editScale_msg{
    padding-left: 30px ;
    margin-bottom: 20px;
    color: red;
  }
</style>


// WEBPACK FOOTER //
// src/views/SiteManagement/MerchantManagement/GeneralDistributor.vue